module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-4 22h-6v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1H6v-2h6v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1h6v2zm0-10h-4v1a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-1H6v-2h4V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1h4v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/distribute-vertical-centers-1.js
// module id = 1099
// module chunks = 14